const s = {
  name: "Cellular",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,0h-7v40h7V0z M38,38h-3V2h3V38z"/>
		<path class="st0" d="M22,9h7v31h-7V9z M24,11v27h3V11H24z"/>
		<path class="st0" d="M18,18h-7v22h7V18z M16,38h-3V20h3V38z"/>
		<path class="st0" d="M7,27H0v13h7V27z M2,38v-9h3v9H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Cellular
};
